import React from 'react';
import '../../css/NotificationBadge.css';

const NotificationBadge = ({ count }) => {
  return (
    <span className="notification-badge">
      {count > 99 ? '99+' : count}
    </span>
  );
};

export default NotificationBadge; 